export default __webpack_public_path__ + "ff57f6aa214a71fa1dd73b0b275fa2d4.png";